import React from 'react';
import TableRow from './table_row.jsx'
import TableEditableRow from './table_editable_row.jsx'
import { withTranslation, Trans } from 'react-i18next';

export default class TableBody extends React.Component {
    render() {
        let isEmpty = this.props.items.length === 0;
        return (
            <tbody>
            {
                    this.props.items.map(
                        (item, index) =>
                            <TableEditableRow key={index} columns={this.props.columns} item={item}
                                isEditable={this.props.isEditable}
                                isEditableRow={this.props.isEditableRows}
                                editItemFunction={this.props.editItemFunction} />)
            }
            </tbody>
       );
    }
}